import { Component, ViewEncapsulation } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-order-wks-quick-actions',
  templateUrl: './order-wks-quick-actions.component.html',
  encapsulation: ViewEncapsulation.None
})
export class OrderWksQuickActionsComponent implements ICellEditorAngularComp {
  agParam: any;

  editOrder() {
    if (this.agParam.data.canEdit) {
      this.agParam.context.componentParent.editOrder(this.agParam.data);
    }
  }

  cancelOrder() {
    if (this.agParam.data.canCancel) {
      this.agParam.context.componentParent.cancelOrder(this.agParam.data);
    }
  }

  replyOrder() {
    this.agParam.context.componentParent.replyOrder(this.agParam.data);
  }

  agInit(params): void {
    this.agParam = params;
  }

  getValue() {
    throw new Error("Method not implemented.");
  }
  isPopup?(): boolean {
    throw new Error("Method not implemented.");
  }
  isCancelBeforeStart?(): boolean {
    throw new Error("Method not implemented.");
  }
  isCancelAfterEnd?(): boolean {
    throw new Error("Method not implemented.");
  }
  focusIn?(): void {
    throw new Error("Method not implemented.");
  }
  focusOut?(): void {
    throw new Error("Method not implemented.");
  }
  afterGuiAttached?(params?): void {
    throw new Error("Method not implemented.");
  }
}
